"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AfterEffectsJobType = void 0;
var AfterEffectsJobType;
(function (AfterEffectsJobType) {
    AfterEffectsJobType["ClipJob"] = "ClipJob";
    AfterEffectsJobType["CeremonyJob"] = "CeremonyJob";
    AfterEffectsJobType["LiveClipPreviewJob"] = "LiveClipPreviewJob";
})(AfterEffectsJobType = exports.AfterEffectsJobType || (exports.AfterEffectsJobType = {}));
//# sourceMappingURL=after-effects-job-type.js.map